/* eslint-disable camelcase */
export default class Detail {
  id = 0;
  created_by = '';
  updated_by = '';
  sequence = '';
  detail_operations = [];
  item_master = {};
  qty = 0;
  description = '';
  created_at = '';
  updated_at = '';
  name = '';
  is_programming_required = 0;

  constructor (detailData) {
    Object.assign(this, detailData)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/Detail.js